export default __webpack_public_path__ + "static/i12-8a6c64fa49e1d7c4a4c36ec37ac31e2d.jpg";